//import libraries
import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import classes
import { Dashboard } from '../classes/dashboard.model';

//import language
import { DashboardLang,DashboardCalendarLang } from '../languages/Dashboard.Lang';

//import services
import { GeneralService } from '../services/general.service';


@Injectable()

export class DashboardService {
	
	constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ) {}

    load_data() : Observable<Dashboard> {
        let url = AppSettings.API_ENDPOINT+AppBackRoutes.dashboard_service;
        return this.http.get<any>(url);
    }

    calendarLang(details: any) {

        if (!details) return;
        let instance = new DashboardCalendarLang(details.language);
        return instance.lang();

    }

    langData(resp: Dashboard){

        if(!resp)
            return;
        
        let lang = {};

        let gen = resp.language.general;
        lang = Object.assign(lang, { general: this.generalService.service_inject(DashboardLang.general, gen) });

        let dash = resp.language.dashboard;
        lang = Object.assign(lang, { dashboard: this.generalService.service_inject(DashboardLang.dashboard, dash) });
        
        return lang;
    }

    dashboardData(resp: Dashboard){
        return (resp) ? resp.userdata : null;
    }


    calendar_data()
    {
        let url = AppSettings.API_ENDPOINT + AppBackRoutes.calendar_data;
        return this.http.get<any>(url);
    }


}